import React from "react";
import SideNavbar from "./helpers/SideNavbar";

const Resources = () => {
  return (
    <SideNavbar>
      <div className="card shadow-sm p-3 mt-3" style={{ border: "none", backgroundColor: "#fff" }}>
        <div className="card-header d-flex justify-content-between" style={{ border: "none", backgroundColor: "#fff" }}>
          <h5 className="welcome-text" style={{ fontSize: "20px", color: "#2e3192", textAlign: "left" }}>
            Resources
          </h5>
        </div>
        <hr />
        <div className="container">
          {[
            {
              title: "Login",
              description: "Secure login tailored for your branding role - Personal, Business, or Agency.",
              videoUrl: "https://www.youtube.com/embed/EyQaE-q2rIM?si=yFyE3a1lQk7_rE6U"
            },
 {
              title: "Profile Hub",
              description:
                "Customize your profile, prompts, and interests with powerful AI-driven tools.​",
              videoUrl: "https://www.youtube.com/embed/MTMY_bOhSPQ?si=mGw799mQm6tTQrJA"
              },
              {
                title: "Create Post",
                description:
                  "Create a post/poll with AI-generated content.​",
                videoUrl: "https://www.youtube.com/embed/yEsFnlYChyI?si=3LkDv9K9yXsJYyh-"
                },
            {
              title: "Content Studio",
              description:
                "Seamlessly manage, schedule, and track all your posts from one unified hub.",
              videoUrl: "https://www.youtube.com/embed/TnI2uAzMjfw?si=2L5Wl1p3VhRrT-RJ"
              },
                                 
             
           
          ].map((section, index) => (
            <div className="row mt-5" key={index}>
              <div className="col-sm-12 col-md-8 col-xl-8 col-lg-8">
                <h4 style={{ color: "#2e3192" }}>{section.title}</h4>
                {section.description && <p>{section.description}</p>}
                {section.listItems && (
                  <ul>
                    {section.listItems.map((item, i) => (
                    <li key={i}>{item.replace(/[\u200B-\u200D\uFEFF]/g, '')}</li>

                    ))}
                  </ul>
                )}
              </div>
              <div className="col-sm-12 col-md-4 col-xl-4 col-lg-4">
            <iframe
        width="100%"
        height="180"
        src={section.videoUrl}
        title={`YouTube video for ${section.title}`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        allowFullScreen
      ></iframe>
              </div>
            </div>
          ))}
        </div>
      </div>
    </SideNavbar>
  );
};

export default Resources;
